import styled from "styled-components";
import { ProfileCashierAddButtonDefaultBox } from "./profile-cashier-add-button.default.box";

export const ProfileCashierAddButtonWsopBox = styled(ProfileCashierAddButtonDefaultBox)`
    @media ${({theme}) => theme.mediaQuery.lowHeight}, ${({theme}) => theme.mediaQuery.xlAndBelow} {
        right: 6px;
    }
    color: ${({theme}) => theme.colors.brandPrimary};
`;
